import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query MFAHasFlag {
    mfaHasFlag
  }
`

export const mfaHasFlagKey = getQueryNames(query)[0]

export default query
